import { motion } from "framer-motion";
import { useRef } from "react";
import { assets } from "@/lib/assets";
import { HeroScanForm } from "@/components/landing/HeroScanForm";

export function LandingHero() {
  const inputRef = useRef(null);
  return (
    <section className="landing-hero hero-upload" data-testid="landing-hero">
      <h1 className="sr-only" data-testid="hero-heading">Your website’s SEO health starts here</h1>
      <div className="hero-artwork">
        <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: .65 }}
        className="hero-upload-image"
        src={assets.landingHero}
        width={1672}
        height={857}
        fetchPriority="high"
        alt="seorank.doctor SEO health illustration: a friendly doctor with a website health dashboard, keyword rankings, AI visibility, and backlink analysis."
        data-testid="landing-hero-image"
        />
        <button type="button" className="hero-mobile-scan-hotspot" aria-label="Enter your website to scan" data-testid="hero-mobile-scan-hotspot" onClick={() => { inputRef.current?.scrollIntoView({ behavior: "smooth", block: "center" }); inputRef.current?.focus({ preventScroll: true }); }}/>
      </div>
      <HeroScanForm inputRef={inputRef}/>
    </section>
  );
}